import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Cart, Order } from '../../interfaces/payment-summary.interface';
import { MatCardModule } from '@angular/material/card';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { AmountPipe } from '../../pipes/amount.pipe';
import { MatIcon } from '@angular/material/icon';
import {MatDialog, MatDialogModule} from '@angular/material/dialog';
import { RemoveFromCartDialogComponent } from '../remove-from-cart-dialog/remove-from-cart-dialog.component';
import { Subject, takeUntil } from 'rxjs';
const NonRemovableProductIds = [
  "prod_I5GWSekQdS",   // $70 Post Season Entry Fee (Hunt Seat National)
  "prod_plsI0nFGtS",   // $70 Post Season Entry Fee (Dressage National)
  "prod_zknd4tlmpH",   // $70 Post Season Entry Fee (Western National)
  "prod_EfrFz1sDHSqt", // $70 National Entry Fees Hunt Seat.
  "prod_EfrFz1sDDrqt", // $70 National Entry Fees Dressage.
  "prod_EfrFz1sDWrqt", // $70 National Entry Fees Western.
]
@Component({
  standalone: true,
  imports: [
    MatCardModule,
    CommonModule,
    MatTableModule,
    AmountPipe,
    MatIcon,
    MatDialogModule
  ],
  selector: 'equine-ui-nx-shopping-cart',
  templateUrl: './shopping-cart.component.html',
  styleUrls: ['./shopping-cart.component.scss']
})
export class ShoppingCartComponent implements OnDestroy {

  @Input() orders: Order[] = [];
  @Input() total = 0;
  @Input() subtotalItems = 0;
  @Input() isAdmin: boolean = false;
  @Output() removeOrderFromCart = new EventEmitter<string>();

  unsubscribe$ = new Subject<void>();

  displayedColumns: string[] = ['item', 'price', 'quantity', 'remove', 'cost'];

  constructor(public dialog: MatDialog) {}

  removeFromCart(order: Order) {
    const nonRemovable = order.purchaseItems.some((itm) => NonRemovableProductIds.includes(itm.referenceId));
    const dialogRef = this.dialog.open(RemoveFromCartDialogComponent, {
      data: {
        orderId: order.id,
        items: order.purchaseItems,
        nonRemovableItems: nonRemovable && !this.isAdmin 
      }
    });

    dialogRef.afterClosed()
      .pipe(
        takeUntil(this.unsubscribe$)
      )
      .subscribe({
        next: (orderId) => {
          this.removeOrderFromCart.emit(orderId);
        }
      })
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

}
